import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Link, useNavigate } from "react-router-dom";

const SurveySuccess = ({ pdfSurvey }) => {
  return (
    <div className="relative flex flex-col justify-center items-center mt-10">
      <div className="w-48 mx-auto">
        <DotLottieReact
          src="https://lottie.host/94b2946b-3008-4b12-9222-54c8265d23da/CGohAzrvbF.lottie"
          autoplay
        />
      </div>
      <div className="font-semibold text-base md:text-xl mt-2">
        Laudo emitido com sucesso!
      </div>
      <div className="flex gap-2 mt-4 justify-center items-center">
        <a
          className="bg-primary text-white rounded-md px-4 py-3 text-sm"
          href={`${pdfSurvey}?t=${Date.now()}`}
          target="_blank"
        >
          Salvar laudo
        </a>
        <Link
          to="/surveys"
          className="bg-gray-500 text-white rounded-md px-7 py-3 text-sm"
        >
          Voltar
        </Link>
      </div>
    </div>
  );
};

export default SurveySuccess;
